import { importoScontoAgo } from "./invoiceDiscounts";
export const VALORIZZAZIONI_AGO_HEADERS = [
  "Data Valorizzazione", "Business Unit", "Formato Codice Cliente", "Codice/C.F./P.IVA Cliente",
  "Compenso", "Descrizione", "Onorari", "Spese/Spese accessorie", "Anticipazioni/Ant. Accessorie",
  "Onorario Accessorio", "Formato Cod. Servizio", "Progressivo servizio Cliente(Codice servizio)",
  "Pratica", "Marginalità", "\u00a0Att. IVA", "Sezionale IVA", "Da non fatturare", "Data competenza Da",
  "Data competenza A", "Quantità (numeri)", "Quantità (tempo)", "Sconto", "Identificativo", "Listino",
  "Data inizio servizio", "Motivo inizio servizio", "Data fine servizio", "Motivo fine servizio",
  "Sede operativa del servizio", "Id valorizzazioni OMNIA", "Ditta/Privato", "Numero proforma OMNIA",
  "Data Proforma OMNIA", "Cod. Anticipazione accessoria", "Operatore", "Professionista di riferimento",
  "Q.ta/Importo tariffa 1", "Q.ta/Importo tariffa 2", "Sospesa", "Importo Unitario", "Importo fisso",
];

const testoAgo = (value) => {
  const normalized = String(value ?? "")
    .replace(/[‘’ʼ＇]/g, "'")
    .replace(/€/g, "EUR")
    .trim().replace(/[;\r\n]+/g, " ");
  return normalized ? `'${normalized.replace(/'+/g, "'")}'` : "";
};

const numeroAgo = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric.toFixed(2) : "";
};

const codiceCompenso = (value) => {
  const normalized = String(value ?? "").trim().replace(/^0+(?=\d)/, "");
  return normalized ? normalized.padStart(5, "0") : "";
};

const codiceClienteAgo = (row) => {
  const tipo = String(row.tipo || "").toUpperCase();
  if (!["I", "II"].includes(tipo)) return row.codice_parcellazione;
  const cliente = String(row.cliente || "");
  if (/HAWK[\s-]*EYE|VELUX|MOBIS/i.test(cliente)) {
    const codice = String(row.codice_parcellazione || "").trim().replace(/^0+(?=\d)/, "");
    return /^\d+$/.test(codice) ? codice.padStart(15, "0") : codice;
  }
  return "000000000000425";
};

export const creaCsvValorizzazioniAgo = (rows) => {
  const body = rows.map((row) => {
    const quantita = Number(row.quantita || 0);
    const totaleMemorizzato = Number(row.importo_totale || 0);
    const importoUnitario = Number(row.importo_unitario || 0);
    const tipo = String(row.tipo || "").toUpperCase();
    const scontoCliente = Number(row.sconto || 0);
    const scontoIipay = Number(row.iipay_sconto_percentuale || 0);
    const isForfaitIipayNetto = ["I", "II"].includes(tipo)
      && row.cliente_diretto_iipay
      && row.sezione === 4
      && scontoIipay > 0
      && scontoIipay < 100;
    const totale = isForfaitIipayNetto
      ? totaleMemorizzato / (1 - scontoIipay / 100)
      : totaleMemorizzato;
    const fields = Array(41).fill("");
    fields[1] = testoAgo("000000000000013");
    fields[2] = "1";
    fields[3] = testoAgo(codiceClienteAgo(row));
    fields[4] = testoAgo(codiceCompenso(row.codice_prestazione));
    fields[5] = testoAgo(row.descrizione);
    fields[6] = numeroAgo(totale);
    const scontoPercentuale = ["I", "II"].includes(tipo) && row.cliente_diretto_iipay && scontoIipay > 0
      ? scontoIipay
      : scontoCliente;
    if (totale > 0 && scontoPercentuale > 0) {
      fields[21] = numeroAgo(importoScontoAgo(totale, scontoPercentuale));
    }
    const isPayrollBpoint = tipo === "B" && Number(row.sezione) === 0;
    if (quantita !== 0 && !isPayrollBpoint) {
      fields[19] = numeroAgo(quantita);
      fields[39] = numeroAgo(importoUnitario);
    } else {
      fields[40] = numeroAgo(totale);
    }
    return fields.join(";");
  });
  return [VALORIZZAZIONI_AGO_HEADERS.join(";"), ...body].join("\r\n");
};

const WINDOWS_1252 = new Map([
  [0x20ac, 0x80], [0x201a, 0x82], [0x0192, 0x83], [0x201e, 0x84], [0x2026, 0x85],
  [0x2020, 0x86], [0x2021, 0x87], [0x02c6, 0x88], [0x2030, 0x89], [0x0160, 0x8a],
  [0x2039, 0x8b], [0x0152, 0x8c], [0x017d, 0x8e], [0x2018, 0x91], [0x2019, 0x92],
  [0x201c, 0x93], [0x201d, 0x94], [0x2022, 0x95], [0x2013, 0x96], [0x2014, 0x97],
  [0x02dc, 0x98], [0x2122, 0x99], [0x0161, 0x9a], [0x203a, 0x9b], [0x0153, 0x9c],
  [0x017e, 0x9e], [0x0178, 0x9f],
]);

export const codificaWindows1252 = (value) => Uint8Array.from([...value].map((char) => {
  const code = char.codePointAt(0);
  if (code <= 0xff) return code;
  return WINDOWS_1252.get(code) ?? 0x3f;
}));
